var lazyVideos = (function () {

    var _opts = {
        selectors: {
            videos: '.lazy-videos__video'
        },
        types: {
            youtube: {
                thumbnail: 'https://img.youtube.com/vi/{{VIDEOID}}/sddefault.jpg',
                embed: 'https://www.youtube.com/embed/{{VIDEOID}}?rel=0&showinfo=0&autoplay=1',
            },
            vimeo: {
                thumbnail: '',
                embed: 'https://player.vimeo.com/video/{{VIDEOID}}?autoplay=1',
            }
        }
    };

    var _formatURL = function (string, id) {
        return string.replace('{{VIDEOID}}', id );
    };

    var _addPlaceholder = function (element, source) {
        var image = new Image();
        image.src = source;
        image.addEventListener("load", function () {
            element.appendChild(image);
        }(element));
    };

    var _setUpVideo = function (element, type ) {
        var source, image, iframe;

        var video_id = element.dataset.embed;

        if( !video_id ) return;

        // =====
        // create image
        if( type === 'youtube' ) {
            source = _formatURL( _opts.types[type].thumbnail, video_id);
            _addPlaceholder(element, source);
        } else {
            $.getJSON('https://vimeo.com/api/v2/video/' + video_id + '.json?callback=?', function (data) {
                source = data[0].thumbnail_medium;
                _addPlaceholder(element, source);
            });
        }

        element.addEventListener("click", function () {

            iframe = document.createElement("iframe");

            iframe.setAttribute("frameborder", "0");
            iframe.setAttribute("allowfullscreen", "");
            iframe.setAttribute("src", _formatURL( _opts.types[type].embed, video_id) );

            this.innerHTML = "";
            this.appendChild(iframe);
        });

    };

    var _attachEvents = function () {
        for( var type in _opts.types ) {
            $( _opts.selectors.videos + '.' + type ).each(function () {
                _setUpVideo( this, type );
            });
        }
    };

    var init = (function() {
        if( $( _opts.selectors.videos ).length ) _attachEvents();
    })();
    // don't know
})();